import { Component, Input, OnInit } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-boyd-my-balance',
  templateUrl: './boyd-my-balance.component.html',
  styleUrls: ['./boyd-my-balance.component.scss'],
})
export class BoydMyBalanceComponent implements OnInit {
  @Input() navigateBackPage;
  
  public title:string;
  public userCurrentLoyaltyProgress;
  public rewardInformation = [];
  public userCurrentLoyaltyPoints;
  public userCurrentLoyaltyLevel;
  public userNextLevelLoyaltyPoints;
  public userCurrentLoyaltyPointsExpiry;
  public userNextLoyaltyLevel;
  private cardImage: string;

  public reedemablePoints;
  public boydCardNumber;
  loyaltyTiers: any[] = [];
  tierLevel: any;
  tierCredits: any;
  customer: CustomerModel

  constructor(
    private successMessageService:SuccessMessageService,
    private utils:UtilsService,
    private boydRewardsService:BoydRewardsService,
    private authenticationService:AuthenticationService,
    private navigator:Navigator,
    private userSessionService:UserSessionService
  ) { 
    this.successMessageService.clearMessage();
   
  }

  ionViewWillEnter(){
      // this.getCardImage();
   }

  //  public getCardImage(): void{
      //  const url = 'icon/boydcard-ruby-big.svg';
      //  this.cardImage = this.utils.getCDNAsset(url);
    // }
  
  ngOnInit() {
    this.title = "BOYD REWARDS DETAILS";
    this.getLoyaltyTiers();
    // this.onGetCustomerLoyaltyPoints();
    this.getBoydCardPointsInfo();
    this.userSessionService.getCustomer().subscribe(
      (customer:CustomerModel) => {
          this.customer = customer;
      }
  );
  }
  getBoydCardPointsInfo() {
    this.boydRewardsService.callGetExternalPointsInfo().subscribe(res => {
      this.boydCardNumber = res.payload.pointsCardNumber;
      this.reedemablePoints = res.payload.redeemablePoints;
      this.tierLevel = res.payload.tierLevel;
      this.tierCredits = res.payload.tierCredits;
      let imgName = "boydcard-" +this.tierLevel+".png";
      // this.cardImage = 'assets/images/'+imgName; Local
      if(this.tierLevel){
        this.cardImage = this.utils.getCDNAsset("imgs/"+imgName);
      }else {
        this.cardImage = this.utils.getCDNAsset("imgs/default-boyd-card.png");
      }
      this.updateRewardBarStyle();
    })
  }
 

  getProgressBarWidth = () => this.userCurrentLoyaltyProgress + '%';

updateRewardBarStyle(){
  let rewardBar = document.getElementsByClassName('reward-bar');
  for (var i = 0; i < rewardBar.length; i++) {
    rewardBar[i].className = rewardBar[i].className.replace('reward-bar','empty-reward-bar')
  }
}

getLoyaltyTiers(){
  // Filling in dummy Data
  let tiers = [
    {
      image:this.utils.getCDNAsset('/imgs/boydcard-ruby-small.png'),
      tier:"Ruby",
      range:"0-749",
    },
    {
      image:this.utils.getCDNAsset('/imgs/boydcard-sapphire-small.png'),
      tier:"Sapphire",
      range:"749-14,999",
    },
    {
      image:this.utils.getCDNAsset('/imgs/boydcard-emerald-small.png'),
      tier:"Emerald",
      range:"15,000-49,999",
    },
    {
      image:this.utils.getCDNAsset('/imgs/boydcard-onyx-small.png'),
      tier:"Onyx",
      range:"50,000-199,999",
    },
    {
      image:this.utils.getCDNAsset('/imgs/boydcard-titanium-small.png'),
      tier:"Titanium",
      range:"200,000+",
    }
  ];
  this.loyaltyTiers = tiers;
  return this.loyaltyTiers;
}

  onBack = () => {
    if (this.navigateBackPage) {
      if (this.navigateBackPage == "default") {
        this.navigator.dismissAll();
      } else {
        this.navigator.navigateTo(this.navigateBackPage);
      }
    } else {
      this.navigator.back();
    }
  };

}
